export enum SidenavActionsType {
  TOGGLE_SIDENAV = '[Sidenav] Toggle open/close the sidenav',
  TOGGLE_TOOLBAR = '[Sidenav] Toggle show/hide the toolbar',
  TOGGLE_CMS_LIST = '[Sidenav] Toggle show/hide the CMS list',
  SET_MOBILE = '[Sidenav] Set mobile resoltion'
}
